const faGamma = {
  prefix: 'fac',
  iconName: 'gamma',
  icon: [345, 512, [], null, 'M214 146 L179 436 L251 444 L286 154 Z M59 185 L209 290 L251 231 L101 126 Z'],
};

export default faGamma;
